/**
 * Default coordinate transformation for all charts.
 */
export var Cartesian = function Cartesian() {
  return [['cartesian']];
};
Cartesian.props = {};